import axios from 'axios';

interface ReviewDetail {
    source_id: string;
    timestamp: string;
    normalized_rating: number;
    responded: boolean;
}

interface LocationReview {
    location_uid: number;
    review_details: ReviewDetail[];
}

interface AIImpactAnalysisContext {
    request_id?: string; // added to the context in node before invoking the api
    location_reviews: LocationReview[];
}

interface AIImpactAnalysisResult {
    location_impacts: LocationImpact[];
}

interface LocationImpact {
    location_uid: number;
    min_impact?: number;
    max_impact?: number;
    no_data: boolean;
}

export const getReviewsAIImpactAnalysis = async (
    tenantId: number | undefined,
    context: AIImpactAnalysisContext,
    args?: Record<string, any>,
): Promise<AIImpactAnalysisResult> => {
    const { data } = await axios.get(`/api/tenants/${tenantId}/common/ai-impact-analysis/reviews`, {
        params: {
            context,
            args,
        },
    });

    return data;
};
